import Environment from './environment';
import HwpTvApi from './hwpTvApi';
import { getLogger } from './logging/logger';
import Readyable from './readyable';

const logger = getLogger('HwpTvAnalytics');

let arcade = '';

class Analytics extends Readyable {
	getTagId() {
		if (!Environment.isProd()) {
			return 'G-M0ZM4M2Y7N';
		}

		return 'G-FG9211M6VF';
	}

	constructor() {
		super();
		logger.log('[constructor]');

		if (!window.globalThis) {
			/**
			 * The gtag script requires globalThis to be defined. Including a check
			 * will force the polyfill to be included in the build. Without it,
			 * analytics fail on older devices.
			 */
			logger.error('globalThis is not defined');
			throw new Error('globalThis is not defined');
		}

		// Add gtag script and wait for load
		const script = document.createElement('script');
		script.async = true;
		script.src = `https://www.googletagmanager.com/gtag/js?id=${this.getTagId()}`;
		script.addEventListener('load', this.onGtagLoaded.bind(this));
		script.addEventListener('error', (error) => this.onReadyReject(error));

		document.head.appendChild(script);
	}

	onGtagLoaded() {
		logger.log(`[${this.onGtagLoaded.name}]`);

		window.dataLayer = window.dataLayer || [];
		function gtag() {
			// eslint-disable-next-line prefer-rest-params
			window.dataLayer.push(arguments);
		}
		window.gtag = gtag;
		this.gtag = gtag;

		const params = new URLSearchParams(window.location.search);

		gtag('js', new Date());
		gtag('config', this.getTagId(), {
			send_page_view: false,
			campaign_name: params.get('utm_campaign'),
			campaign_source: params.get('utm_source'),
			campaign_medium: params.get('utm_medium'),
		});

		this.onReadyResolve();
	}

	/**
	 * Sets the user ID for the Google Analytics tracking.
	 * @param {string} userId - The user ID to set for the Google Analytics tracking.
	 */
	setUserId(userId) {
		logger.log(`[${this.setUserId.name}]`, { userId });

		this.gtag?.('set', { user_id: userId });
	}

	/**
	 * Sets the current arcade for analytics tracking.
	 * @param {string} newArcade - The new arcade to set for analytics tracking.
	 */
	setArcade(newArcade) {
		logger.log(`[${this.setArcade.name}]`, { newArcade });

		arcade = newArcade;
	}

	/**
	 * Logs analytic event to GA4 analytic system
	 * @param {String} eventName The name of the event
	 * @param {Object} [eventData] Any data associated with the event. ex {category, action, label, value}
	 */
	sendEvent(eventName, eventData = {}) {
		logger.log(`[${this.sendEvent.name}]`, { eventName, eventData });

		if (this.gtag) {
			this.gtag('event', eventName, { arcade, ...eventData });
		} else {
			logger.warn('Missing gtag function for Google Analytics');
		}

		return HwpTvApi.logEvent(arcade, eventName, eventData);
	}
}

export default new Analytics();
